export default __webpack_public_path__ + "static/media/visual_m.cf158297.jpg";